import { useQueryClient } from '@tanstack/react-query'
import { getQueryKey } from '~/services'
import { resolveKey } from '~/services/preferences/preferences'
import { setWorkspacePreference, SetWorkspacePreferencePropsUnion } from '~/services/preferences/workspacePreferences'

type Props = { onSuccess?: () => void } & SetWorkspacePreferencePropsUnion

export const useAsyncSetWorkspacePreferences = (workspaceId: string) => {
  const queryClient = useQueryClient()

  return async ({ onSuccess, ...props }: Props) => {
    try {
      const result = await setWorkspacePreference(props, workspaceId)

      const queryKey = getQueryKey('workspaces_/$workspaceId_/preferences/$path', {
        path: resolveKey(props),
        workspaceId,
      })
      await queryClient.invalidateQueries({ queryKey })

      onSuccess?.()

      return result
    } catch (error) {
      console.error('Error updating user workspace preferences', error)
    }
  }
}
